import React from 'react';
import moment from 'moment';

import { withInteractiveStore } from './TemplateWithInteractiveStore';
import { SanitizedHtml } from '.';
import { Instructions } from './Instructions';

const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

const TimelineWithoutStore = ({interactive, assets, ...props}) => {
  const { bg = {}, events, id, theme, title } = interactive;
  const showInstructions = props.forwardedRef ? true : false;
  
  const parseFormData = () => {
    const timeline = [];
    if (!events) {
      return timeline;
    }
    const eventsCopy = [...events];

    eventsCopy.sort(compareEventDates)
  
    eventsCopy.forEach((propEvent, index) => {
      const event = {...propEvent}
      const label = renderDateLabel(event.date)
      let prevEvent;

      if (!label) {
        return;
      }

      if (index) {
        prevEvent = eventsCopy[index - 1];
      }

      if (prevEvent) {
        let prevMo = moment(prevEvent.date);
        let currMo = moment(event.date);

        // if the difference between the last number and this number is 2, (i.e., it skips a day) add a day to the timeline
        // if it is greater, add a break.
        if (currMo.diff(prevMo, 'days') >= 2) {
          let nextDate = new Date(prevEvent.date);
          nextDate.setDate(nextDate.getDate() + 1);
          timeline.push({
            label: renderDateLabel(nextDate),
            events: [],
            // if it is greater than 2, add a break.
            break: ((currMo.diff(prevMo, 'days') > 2) ? true : false)
          })
        } 
      }

      event.count = index + 1;
      if (timeline.length && timeline[timeline.length - 1].label === label) {
        timeline[timeline.length - 1].events.push(event)
      } else {
        timeline.push({
          label,
          events: [event]
        })
      }
    })

    let lastDate = new Date(events[events.length - 1].date);
    lastDate.setDate(lastDate.getDate() + 1);
    timeline.push({
      label: renderDateLabel(lastDate),
      events: []
    })
    
    
    return timeline;
  }

  const compareEventDates = (a,b) => {
    const a2 = getMomentFromDate(a);
    const b2 = getMomentFromDate(b);
    
    let granularity = 'minute';
    
    if (!a.time || !b.time) {
      granularity = 'day';
    }

    // If less than 0, sort a to an index lower than b (i.e. a comes first).
    // If 0, leave a and b unchanged with respect to each other
    // If greater than 0, sort b to an index lower than a (i.e. b comes first).
    if ( a2.isBefore(b2, granularity) ) {
      return -1;
    } 
    if ( a2.isAfter(b2, granularity) > 0) {
      return 1;
    }
    return 0;
  }


  const getMomentFromDate = a => {
    const a2 = moment(a.date)
    if (!a.time || typeof a.time.numbers !== 'string') {
      return a2;
    }
    let hours = parseInt(a.time.numbers.split(':')[0]);
    const mins = parseInt(a.time.numbers.split(':')[1]);

    // adjust time to 24hr
    if (a.time.ampm === 'PM' && hours !== 12) {
      hours = hours + 12;
    } else if (a.time.ampm === 'AM' && hours === 12) {
      hours = hours - 12;
    }

    a2.set({
      'hour': hours,
      'minute': mins
    })
    return a2;
  }

  const renderDateLabel = date => {
    
    if (Object.prototype.toString.call(date) !== '[object Date]') {
      return false;
    }
    const day = date.getDate();
    const month = months[date.getMonth()];
    const year = date.getFullYear();
    return `<span>${month}</span><span class="big">${day}</span><span class="tiny">${year}</span>`
  }

  const renderLine = (timeline) => {
    let above = true;
    let first = true;
    let timelineHasBreak = false;
    return (
      <div className="dinfos-timeline__nav" aria-hidden="true">
        <div className="dinfos-timeline__line"></div>
        <div className="dinfos-timeline__increments dinfos-drag-scroll-x" aria-controls={`${id}-track`}>

          {timeline.map((increment, iIndex) => {
            let below_extra = false;
            let above_extra = false;
            if (increment.break) {
              timelineHasBreak = true;
            }
            return (
              <React.Fragment key={iIndex}>
                <SanitizedHtml className="dinfos-timeline__increment-label" content={increment.label} />
                <div className="dinfos-timeline__increment">
                  {increment.break ? 
                    <div className="dinfos-timeline__increment-break"></div>
                  : ''}
                  {increment.events.map((event, eIndex) => {
                    const eventFlag = (
                      <div 
                        key={eIndex}
                        className={`dinfos-timeline__event
                          ${above ? 'dinfos-timeline__event--above' : 'dinfos-timeline__event--below' }
                          ${ (above_extra && above) || (below_extra && !above) ? 'dinfos-timeline__event--extra' : '' }
                          ${ first ? 'dinfos-timeline__event--active' : '' }
                        `}
                        data-go-to-slide={event.count}
                      >
                        <button tabIndex="-1" type="button" id={`${id}-node-${event.count}`} className="btn dinfos-btn dinfos-timeline__node" aria-labelledby={`#${id}-flag-${event.count}`}></button>
                        <div className="dinfos-timeline__flag" id={`${id}-flag-${event.count}`}>{event.flagTitle ? event.flagTitle : event.headline}</div>
                      </div>
                    )

                    if (above) {
                      above = false;
                      above_extra = !above_extra;
                    } else {
                      above = true;
                      below_extra = !below_extra;
                    }
                    first = false;
                  
                    return eventFlag;
                    
                  })}
                    
                    
                </div>
              </React.Fragment>
            )
          })}
            
        </div>
        
        {timelineHasBreak ?
          <div className="dinfos-timeline__legend" aria-hidden="true">
            <div className="dinfos-timeline__break-wrapper">
              <div className="dinfos-timeline__line"></div>
              <div className="dinfos-timeline__increment-break"></div>
            </div>
            Period without events
          </div>
        : '' }

      </div>
    )
  }

  const timeline = parseFormData();

  if (!id) {
    return <div></div>
  }

  return (
    <div id="interactive-template" ref={props.forwardedRef}>
      <div className="dinfos-intv__wrapper"> 
        <section className={`dinfos-timeline dinfos-timeline--${theme} ${showInstructions ? 'overflow-hidden' : ''}`} id={id} aria-label="Timeline"  data-intv>
          <h2 className="sr-only">{title}</h2>

          <Instructions hide={!showInstructions} instructions="Navigate the timeline by selecting points of information." id={`${id}-instr`} />

          {renderLine(timeline)}

          <div className="dinfos-timeline__slides" style={bg && bg.src ? {backgroundImage:`url(${assets[bg.src]})`} : {}} data-src={bg && bg.src ? bg.src : null }>

            <button type="button" className="btn dinfos-btn dinfos-timeline__arrow dinfos-timeline__arrow--left" disabled aria-label="Go to previous event" data-go-to-slide="0"><i className="fas fa-arrow-left"></i></button>
            <button type="button" className="btn dinfos-btn dinfos-timeline__arrow dinfos-timeline__arrow--right" aria-label="Go to next event" data-go-to-slide="2"><i className="fas fa-arrow-right"></i></button>

            <div className="dinfos-timeline__slides-track" id={`#${id}-track`}>
            {timeline.map((increment, iIndex) => {
              return (
                increment.events.map((event,eIndex)=> {
                  return (
                    <div 
                      key={eIndex}
                      className={`dinfos-timeline__slide ${event.count === 1 ? 'dinfos-timeline__slide--active' : ''}`}
                      data-slide={event.count} 
                      id={`${id}-slide-${event.count}`}>

                      <div className="dinfos-timeline__text">
                        <h3 className="dinfos-timeline__slide-title">
                          <div className="dinfos-timeline__eyebrow">
                            <span className="dinfos-timeline__pill">{`${months[event.date.getMonth()]} ${event.date.getDate()}, ${event.date.getFullYear()}`}</span>
                              { event.time ? <span>{event.time.numbers} {event.time.ampm}</span> : '' }
                          </div>
                          <div className="dinfos-timeline__headline">{event.headline}</div>
                        </h3>
                        <div className="dinfos-timeline__body"><SanitizedHtml content={event.body} /></div>
                        <div className="dinfos-timeline__counter">{event.count}/{events.length}</div>
                      </div>
                      
                      <div className="dinfos-timeline__image-wrapper">
                        {event.image && event.image.src ?
                          <figure className="dinfos-timeline__image">
                            {/* eslint-disable-next-line */}
                            <img src={assets[event.image.src]} data-src={event.image.src}/>
                            <figcaption className="sr-only"><SanitizedHtml content={event.image.screenreader_caption} /></figcaption>
                          </figure>
                        : '' }
                      </div>
                    </div>
                  )
                }) 
              )
            })}
              
            </div>

          </div> 

        </section>
      </div>
    </div>
  )
}


export const Timeline = withInteractiveStore(
  TimelineWithoutStore,
);